module.exports = __webpack_public_path__ + "static/media/S-11-Y.0164a6b7.mp3";